export default __webpack_public_path__ + "static/media/logo_v2.13d2c5bf.svg";